export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Italic-b0568cc57d25847ce1606bcbf8d72499.woff";